import {
  FormControl,
  Box,
  FormHelperText,
  Slider,
  Typography,
} from '@mui/material';
import type { SliderProps } from '@mui/material';

interface MaxNewTokensFieldProps {
  value: number;
  setValue: (value: number) => void;
}

export default function MaxNewTokensField({
  value,
  setValue,
  ...rest
}: MaxNewTokensFieldProps) {
  const handleChange: NonNullable<SliderProps['onChange']> = (
    _event,
    newValue,
  ) => {
    setValue(parseInt(String(newValue)));
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <Typography>Max New Tokens</Typography>
        <Slider
          {...rest}
          aria-label='Temperature'
          value={value}
          valueLabelDisplay='auto'
          aria-describedby='max-new-tokens-helper-text'
          onChange={handleChange}
          min={0}
          max={1024 * 16}
        />

        <FormHelperText id='max-new-tokens-helper-text'>
          The maximum numbers of tokens to generate, ignoring the number of
          tokens in the prompt.
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
